export default __webpack_public_path__ + "static/media/Bobson Dugnutt.e39eb264.jpg";